var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{class:[
    'flex justify-between items-center p-4',
    _vm.highlight ? 'bg-yellow-50 font-semibold' : 'bg-white hover:bg-gray-50'
  ]},[_c('span',{staticClass:"text-gray-700 font-medium"},[_vm._v(_vm._s(_vm.label)+":")]),_c('span',{class:[
      'text-right',
      _vm.highlight ? 'text-lg font-bold text-green-600' : 'text-gray-900'
    ]},[_vm._v(" "+_vm._s(_vm.value)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }